module.exports = __webpack_public_path__ + "assets/img/empty-info.e0b15145.png";